var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("Webheader.history"),
        "show-filter": true,
        "show-refresh": true,
        "show-extract": _vm.inboxMessages.length > 0,
        "filter-expanded": _vm.displayFilter,
        "refresh-disabled": _vm.activateSpinner,
        "extract-disabled": _vm.activateSpinner,
      },
      on: {
        "toggle-filter": function ($event) {
          _vm.displayFilter = !_vm.displayFilter
        },
        refresh: _vm.refreshInbox,
        extract: _vm.extractCSV,
      },
    },
    [
      _c(
        "template",
        { slot: "filterContent" },
        [
          _c("app-panel", {
            attrs: {
              filters: _vm.filterConfig,
              searchAriaLabel:
                _vm.$t("common.srch") + " " + _vm.$t("Webheader.history"),
            },
            on: {
              "filter-changed": _vm.onFilterChanged,
              "clear-filters": _vm.clearFilterFields,
              "apply-filters": _vm.applyFilter,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { staticClass: "listPage", attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c(
                      "div",
                      { staticClass: "requestsList" },
                      [
                        _c(
                          "b-row",
                          { staticClass: "min-w-100" },
                          [
                            _c(
                              "b-col",
                              { attrs: { sm: "12", lg: "12", cols: "12" } },
                              [
                                _vm.activateSpinner
                                  ? _c("spinner")
                                  : _c(
                                      "div",
                                      { staticClass: "w-100" },
                                      [
                                        _vm.inboxMessages.length
                                          ? _c("b-table", {
                                              key: _vm.resetHisto,
                                              staticClass:
                                                "table mt-3 text-center table-striped",
                                              attrs: {
                                                responsive: "",
                                                hover: "",
                                                borderless: "",
                                                outlined: "",
                                                items: _vm.inboxMessages,
                                                fields: _vm.historyFields,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "cell(dateAction)",
                                                    fn: function (data) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "cursor text-ellipsis",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getDate(
                                                                    data.value
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(name)",
                                                    fn: function (data) {
                                                      return [
                                                        !data.value
                                                          ? _c("div", [
                                                              _vm._v("-"),
                                                            ])
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  data.value
                                                                )
                                                              ),
                                                            ]),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(label)",
                                                    fn: function (data) {
                                                      return [
                                                        !_vm.translateDetails(
                                                          data.item.details,
                                                          data.item
                                                        ).length
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  data.value
                                                                )
                                                              ),
                                                            ])
                                                          : _c(
                                                              "f7-accordion-item",
                                                              {
                                                                staticClass:
                                                                  "accordionForm",
                                                                attrs: {
                                                                  expanded:
                                                                    data.item
                                                                      .open,
                                                                },
                                                                on: {
                                                                  "accordion:open":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      data.item.open = true
                                                                    },
                                                                  "accordion:opened":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      data.item.openFinished = true
                                                                      _vm.resetHisto =
                                                                        !_vm.resetHisto
                                                                    },
                                                                  "accordion:close":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      data.item.open =
                                                                        data.item.open = false
                                                                    },
                                                                  "accordion:closed":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      data.item.openFinished = false
                                                                      _vm.resetHisto =
                                                                        !_vm.resetHisto
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "f7-accordion-toggle",
                                                                  {
                                                                    staticClass:
                                                                      "accordionToggle",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form-group row justify-content-center",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "col-sm-auto",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              " +
                                                                                _vm._s(
                                                                                  data.value
                                                                                ) +
                                                                                "\n                              "
                                                                            ),
                                                                            data
                                                                              .item
                                                                              .open ===
                                                                            true
                                                                              ? _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "ml-1 mt-1 fa-light fa-chevron-down color-var-actionButtonColorBlue",
                                                                                  }
                                                                                )
                                                                              : _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "ml-1 fa-light fa-chevron-right color-var-actionButtonColorBlue",
                                                                                  }
                                                                                ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "f7-accordion-content",
                                                                  {
                                                                    class: {
                                                                      accordionContentExpended:
                                                                        data
                                                                          .item
                                                                          .openFinished,
                                                                    },
                                                                  },
                                                                  _vm._l(
                                                                    _vm.translateDetails(
                                                                      data.item
                                                                        .details,
                                                                      data.item
                                                                    ),
                                                                    function (
                                                                      detail,
                                                                      index
                                                                    ) {
                                                                      return _c(
                                                                        "div",
                                                                        {
                                                                          key: index,
                                                                        },
                                                                        [
                                                                          _vm.isRTPAction(
                                                                            data.item
                                                                          )
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "cursor",
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.detailsRTP(
                                                                                          data.item
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "u",
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                          " +
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "history.rtp_details"
                                                                                            )
                                                                                          )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _c(
                                                                                "span",
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _c(
                                                                                        "b",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              detail.name
                                                                                            ) +
                                                                                              " "
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  detail.old
                                                                                    ? _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              detail.old
                                                                                            ) +
                                                                                              " "
                                                                                          ),
                                                                                          _c(
                                                                                            "b",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "→"
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          detail.value
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                        ]
                                                                      )
                                                                    }
                                                                  ),
                                                                  0
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                2206871754
                                              ),
                                            })
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-center mt-5",
                                              },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("common.no_result")
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.activateSpinner
                ? _c(
                    "b-row",
                    { staticClass: "mt-1" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("cm-pagination", {
                            attrs: {
                              maxResultsByPage: _vm.paginationObject.maxResults,
                              firstIndex: _vm.paginationObject.firstIndex,
                              nbResultsTotal:
                                _vm.paginationObject.nbResultsTotal,
                              refreshEvent: _vm.paginationObject.refresh,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }